import { useMemo } from 'react';

export const useTopToolbarController = ({
  // State
  selectedNodeIds,
  isLiveMode,
  isSaving,
  viewportWidth,
  activeBreakpoint,

  // Handlers
  onSave,
  onToggleLiveMode,
  onShowSettings,
  onClose,
  setViewportWidth,
  setActiveBreakpoint,

  // Functions
  getBreadcrumbs,
  setContextAtIndex
}) => {
  const controller = useMemo(() => ({
    // Data
    breadcrumbs: getBreadcrumbs(),
    selectedCount: selectedNodeIds.length,
    isLiveMode,
    isSaving,
    viewportWidth,
    activeBreakpoint,

    // Handlers
    onNavigate: (index) => setContextAtIndex(index),
    onSave,
    onToggleLiveMode,
    onShowSettings,
    onClose,
    setViewportWidth,
    setActiveBreakpoint
  }), [
    selectedNodeIds,
    isLiveMode,
    isSaving,
    viewportWidth,
    activeBreakpoint,
    onSave,
    onToggleLiveMode,
    onShowSettings,
    onClose,
    setViewportWidth,
    setActiveBreakpoint,
    getBreadcrumbs,
    setContextAtIndex
  ]);

  return controller;
};
